export default "__VITE_ASSET__DhaVSZxQ__"